const routes = {
  getBuyerIds: 'buyerIds',
  getBuyerIdHistoryLogs: 'buyerIds/logs',
  createBuyerId: 'buyerIds/add',
  updateBuyerId: 'buyerIds/update',
  deleteBuyerId: 'buyerIds/delete',
  createBusinessLocation:'system/business/locations/add',
  updateBusinessLocation:'system/business/locations/update'
};

export default routes